import { Buffer } from 'buffer';
import { fileForUri } from './fileRegistry';

(globalThis as unknown as { Buffer: typeof Buffer }).Buffer = Buffer;

// React Native accepts `{ uri, name, type }` as a FormData file; browsers need a Blob.
const append = FormData.prototype.append as (this: FormData, name: string, value: string | Blob, filename?: string) => void;
FormData.prototype.append = function (name: string, value: unknown, filename?: string) {
  if (value && typeof value === 'object' && !(value instanceof Blob) && 'uri' in value) {
    const file = value as { uri: string; name?: string; type?: string };
    const blob = fileForUri(file.uri);
    if (blob) return append.call(this, name, blob, file.name ?? filename ?? 'file');
  }
  // Pass `filename` only when given: append(name, string, undefined) throws in some engines.
  return filename === undefined
    ? append.call(this, name, value as string | Blob)
    : append.call(this, name, value as string | Blob, filename);
};
